const API = {
    ASSETS: '/user/assets',
    PROFILE: '/user/profile',
    TRANSACTION: '/user/transaction',
    WALLET: '/user/wallets'
}
  
export {
    API
}